export default function refreshAds() {
	let attempts = 0;

	try {
		attempts++;
		(adsbygoogle = window.adsbygoogle || []).push({});
	} catch {
		if (attempts < 10) setTimeout(refreshAds, 1000);
	}
}
